export default class RequestError extends Error {
  public readonly responseStatus: number;
  public readonly code?: string;
  public readonly name: string;
  public readonly stack?: string;
  public readonly requestDetails?: unknown;

  constructor(
    message: string,
    responseStatus: number,
    name: string,
    stack?: string,
    code?: string,
    requestDetails?: unknown,
  ) {
    super(message);
    this.responseStatus = responseStatus;
    this.name = name;
    this.stack = stack;
    this.code = code;
    this.requestDetails = requestDetails;
  }
}
